import styled from "styled-components";

const HeaderStyle = styled.div`
  height: 3.4rem;
  display: flex;
  align-items: center;
  box-shadow: 2px 2px 4px #b5b5b5;
  .logo-img {
    width: 6rem;
    margin-left: 1rem;
  }
`;

export default HeaderStyle;
